import React from "react";
import { Outlet, Navigate } from "react-router-dom";

const PublicRoute = ({ isAllowed, redirectPath = "/dashboard", children }) => {
  if (isAllowed) {
    return <Navigate to={redirectPath} replace />;
  }
  return children ? children : <Outlet />;
};

export default PublicRoute;
